import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=1c5081fa&scoped=true&"
import script from "./Region.vue?vue&type=script&lang=js&"
export * from "./Region.vue?vue&type=script&lang=js&"
import style0 from "./Region.vue?vue&type=style&index=0&id=1c5081fa&lang=scss&scoped=true&"
import style1 from "./Region.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5081fa",
  null
  
)

export default component.exports